(() => {
  const STYLE_MARKER = 'data-oracool-shopify-forms-style';
  const HEADING_SELECTOR = '[class*="_textHeading_"]';
  const SUBMIT_SELECTOR = '[class*="_formSubmitButton_"]';

  let primaryButtonBackgroundCss = '';

  function hasShopifyFormsContent(root) {
    return Boolean(root.querySelector(`${HEADING_SELECTOR}, ${SUBMIT_SELECTOR}`));
  }

  function resolvePrimaryButtonBackgroundCss() {
    if (primaryButtonBackgroundCss) return primaryButtonBackgroundCss;

    const probe = document.createElement('button');
    probe.className = 'btn';
    probe.type = 'button';
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;';
    document.body.appendChild(probe);

    const { backgroundImage } = getComputedStyle(probe);
    probe.remove();

    primaryButtonBackgroundCss =
      backgroundImage && backgroundImage !== 'none'
        ? 'background-color: transparent !important; background-image: var(--primary-btn-bg-gradient) !important;'
        : 'background-color: var(--primary-btn-bg-color) !important; background-image: none !important;';

    return primaryButtonBackgroundCss;
  }

  function buildStylesheet() {
    return `
      ${HEADING_SELECTOR} {
        font-size: 28px !important;
        font-family: var(--heading-font-stack);
        font-weight: var(--font-weight-header-bold, 700);
        line-height: var(--heading-line-height, 1.45);
        letter-spacing: var(--heading-spacing, normal);
      }

      ${SUBMIT_SELECTOR},
      ${SUBMIT_SELECTOR} * {
        font-weight: 700 !important;
      }

      ${SUBMIT_SELECTOR} {
        -webkit-user-select: none;
        user-select: none;
        display: inline-block;
        padding: var(--button-padding-y, 16px) var(--button-padding-x, 20px);
        width: auto;
        min-width: 0;
        margin: 0;
        position: relative;
        overflow: hidden;
        text-decoration: none;
        text-align: center;
        vertical-align: middle;
        line-height: var(--button-line-height, 1);
        cursor: pointer;
        border: 0;
        border-radius: var(--alt-btn-border-radius);
        ${resolvePrimaryButtonBackgroundCss()}
        color: var(--primary-btn-text-color) !important;
        font-family: var(--button-font-stack);
        font-style: var(--button-font-style);
        text-transform: var(--button-text-case);
        font-size: var(--button-font-size-px);
        letter-spacing: var(--button-text-spacing-px);
        appearance: none;
        -webkit-appearance: none;
        box-shadow: none;
      }

      ${SUBMIT_SELECTOR}:hover {
        opacity: 0.92;
      }

      ${SUBMIT_SELECTOR}:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    `;
  }

  function injectStyles(container, markerValue) {
    if (container.querySelector(`style[${STYLE_MARKER}="${markerValue}"]`)) return;

    const style = document.createElement('style');
    style.setAttribute(STYLE_MARKER, markerValue);
    style.textContent = buildStylesheet();
    container.appendChild(style);
  }

  function applySubmitButtonFontWeight(root) {
    root.querySelectorAll(SUBMIT_SELECTOR).forEach((button) => {
      button.style.setProperty('font-weight', '700', 'important');
      button.querySelectorAll('*').forEach((child) => {
        child.style.setProperty('font-weight', '700', 'important');
      });
    });
  }

  function styleShadowRoot(shadowRoot) {
    if (!hasShopifyFormsContent(shadowRoot)) return;

    injectStyles(shadowRoot, 'shadow');
    applySubmitButtonFontWeight(shadowRoot);

    shadowRoot.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) {
        styleShadowRoot(element.shadowRoot);
      }
    });
  }

  function styleShopifyForms() {
    if (hasShopifyFormsContent(document)) {
      injectStyles(document.head, 'light');
      applySubmitButtonFontWeight(document);
    }

    document.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) {
        styleShadowRoot(element.shadowRoot);
      }
    });
  }

  const observedRoots = new WeakSet();

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    styleShopifyForms();

    const observer = new MutationObserver(() => styleShopifyForms());
    observer.observe(root, { childList: true, subtree: true });

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) {
        observeRoot(element.shadowRoot);
      }
    });
  }

  function init() {
    if (!document.body) return;
    observeRoot(document.body);
    styleShopifyForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
